import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@nesso/ui/primitives/table';

import type { Payment } from '@/entities/payment';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';
import { formatNumericShortDate } from '@/shared/lib/time-utils';

type Props = {
    appliedTo: Payment['appliedTo'];
};

export function RefundPaymentSheetServices({ appliedTo }: Props) {
    const totalCents = appliedTo.reduce((sum, line) => sum + line.amountCents, 0);

    return (
        <section className="flex flex-col gap-4 pb-6">
            <h3 className="text-lg font-bold">Services</h3>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead variant="plain">Service</TableHead>
                        <TableHead variant="plain" className="pr-5 text-right">
                            Amount
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody className="[&_tr:last-child]:border-b">
                    {appliedTo.map((line) => (
                        <TableRow key={line.sessionChargeId} className="h-18">
                            <TableCell>
                                <div className="flex flex-col">
                                    <span className="font-semibold">{line.serviceCode}</span>
                                    <span className="text-muted-foreground">
                                        {formatNumericShortDate(line.date)}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell className="pr-5 text-right">
                                {formatCurrencyFromCents(line.amountCents)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <div className="mt-2 ml-auto flex w-56.25 items-center justify-between pr-5 text-sm font-bold">
                <span>Total</span>
                <span className="w-17 text-right">{formatCurrencyFromCents(totalCents)}</span>
            </div>
        </section>
    );
}
